<script>
    import {onMount} from 'svelte';

    import store from '../../Stores/tipo-de-jornada-store';
    import {validaTipoDeJornada} from '../../Modelos/TipoDeJornada';

    import {goto, url} from '@sveltech/routify';

    import Loading from "../../Components/UI/Loading.svelte";
    import Error from "../../Components/UI/Error.svelte";
    import Titulo from "../../Components/UI/Titulo.svelte";
    import Migas from "../../Components/UI/Migas/Migas.svelte";
    import Miga from "../../Components/UI/Migas/Miga.svelte";
    import Formulario from "../../Components/TiposDeJornada/Edicion/Formulario.svelte";

    onMount(() => store.nuevo());

    let tipoDeJornada, error;
    $: tipoDeJornada = $store.tipo;
    $: error = $store.error;
</script>

<style>
    h2 .material-icons {
        font-size: 2.5em;
        vertical-align: bottom;
        line-height: 1;
    }

    @media (min-width: 1024px) {
        .fila {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: var(--padding-global);
        }

        .fila-3 {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-gap: var(--padding-global);
        }
    }
</style>

<svelte:head>
    <title>Nuevo tipo de jornada</title>
</svelte:head>

<Migas>
    <Miga url={$url('/tipos-de-jornada')}>Tipos de jornada</Miga>
    <Miga actual>Nuevo tipo de jornada</Miga>
</Migas>

<Titulo>Nuevo tipo de jornada</Titulo>

{#if $store.cargando}
    <Loading/>
{:else if error}
    <Error mensaje={error} on:cancel={() => error = null}/>
{:else if tipoDeJornada}
    <Formulario on:enviado={() => $goto('/tipos-de-jornada')}/>
{/if}